import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.65 9.8V7h.7v2.8h-.7z" /><path fillRule="evenodd" clipRule="evenodd" d="M3.85 4.2v-.933C3.85 1.477 5.247 0 7 0s3.15 1.476 3.15 3.267V4.2h1.75v8.4H2.1V4.2h1.75zm.7-.933C4.55 1.836 5.66.7 7 .7s2.45 1.136 2.45 2.567V4.2h-4.9v-.933zM11.2 11.9v-7H2.8v7h8.4z" /></svg>;